import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  FaFacebook, 
  FaInstagram, 
  FaTwitter, 
  FaYoutube,
  FaHome,
  FaFish,
  FaShoppingCart,
  FaUser,
  FaArrowUp,
  FaEnvelope,
  FaTshirt,
  FaWater,
  FaInfoCircle,
  FaQuestionCircle,
  FaTruck,
  FaUndo,
  FaShieldAlt,
  FaFileAlt,
  FaCode,
  FaHeart
} from 'react-icons/fa';
import { MdPets, MdOutlineLocalShipping } from 'react-icons/md';
import { GiFishbone, GiAquarium, GiHook } from 'react-icons/gi';
import logo from "../assests/Untitled design.png"

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [email, setEmail] = useState('');
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };
    
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      console.log('Subscribed with email:', email);
      alert('Thank you for subscribing to Lion Head updates!');
      setEmail('');
    }
  };

  const footerLinks = {
    fishFood: {
      title: "Fish Food",
      icon: <GiFishbone className="text-[#1770b6] text-lg" />,
      links: [
        { name: "Premium Pellets", path: "/", icon: <GiFishbone className="text-sm" /> },
        { name: "Growth Formula", path: "/", icon: <GiFishbone className="text-sm" /> },
        { name: "Color Enhancer", path: "/", icon: <GiFishbone className="text-sm" /> },
        { name: "Probiotic Blend", path: "/", icon: <GiFishbone className="text-sm" /> }
      ]
    },
    fish: {
      title: "Fish Species",
      icon: <FaFish className="text-[#1770b6] text-lg" />,
      links: [
        { name: "Tropical Fish", path: "/", icon: <FaFish className="text-sm" /> },
        { name: "Goldfish", path: "/", icon: <FaFish className="text-sm" /> },
        { name: "Cichlids", path: "/", icon: <FaFish className="text-sm" /> },
        { name: "Marine Fish", path: "/", icon: <FaFish className="text-sm" /> }
      ]
    },
    supplies: {
      title: "Aquarium Supplies",
      icon: <GiAquarium className="text-[#1770b6] text-lg" />,
      links: [
        { name: "Filters & Pumps", path: "/", icon: <FaWater className="text-sm" /> },
        { name: "Aquarium Decor", path: "/", icon: <GiAquarium className="text-sm" /> },
        { name: "Water Conditioners", path: "/", icon: <FaWater className="text-sm" /> },
        { name: "Test Kits", path: "/", icon: <MdPets className="text-sm" /> }
      ]
    },
    company: {
      title: "Company",
      icon: <FaInfoCircle className="text-[#1770b6] text-lg" />,
      links: [
        { name: "About Us", path: "/about", icon: <FaInfoCircle className="text-sm" /> },
        { name: "Our Story", path: "/", icon: <FaInfoCircle className="text-sm" /> },
        { name: "Certifications", path: "/", icon: <FaShieldAlt className="text-sm" /> },
        { name: "Blog", path: "/", icon: <FaFileAlt className="text-sm" /> }
      ]
    },
    support: {
      title: "Support",
      icon: <FaQuestionCircle className="text-[#1770b6] text-lg" />,
      links: [
        { name: "Contact Us", path: "/contact", icon: <FaQuestionCircle className="text-sm" /> },
        { name: "FAQs", path: "/", icon: <FaQuestionCircle className="text-sm" /> },
        { name: "Shipping Info", path: "/", icon: <MdOutlineLocalShipping className="text-sm" /> },
        { name: "Returns", path: "/", icon: <FaUndo className="text-sm" /> }
      ]
    },
    legal: {
      title: "Legal",
      icon: <FaShieldAlt className="text-[#1770b6] text-lg" />,
      links: [
        { name: "Privacy Policy", path: "/", icon: <FaShieldAlt className="text-sm" /> },
        { name: "Terms of Service", path: "/", icon: <FaFileAlt className="text-sm" /> },
        { name: "Cookie Policy", path: "/", icon: <FaFileAlt className="text-sm" /> }
      ]
    }
  };

  const socialLinks = [
    { name: "Facebook", icon: <FaFacebook />, url: "https://facebook.com", color: "#1877f2" },
    { name: "Instagram", icon: <FaInstagram />, url: "https://instagram.com", color: "#e4405f" },
    { name: "Twitter", icon: <FaTwitter />, url: "https://twitter.com", color: "#1da1f2" },
    { name: "YouTube", icon: <FaYoutube />, url: "https://youtube.com", color: "#ff0000" }
  ];

  // Developer Credit Component
  const DeveloperCredit = () => (
    <div className="mt-6 pt-4 border-t border-gray-800 text-center">
      <a
        href="https://weeboste.com"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center gap-2 group"
      >
        <span className="text-gray-500 text-xs">Developed by</span>
        <img 
          src="https://weeboste.com/logo.png" 
          alt="Weeboste" 
          className="h-5 w-auto object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'inline-flex';
          }}
        />
        <span 
          className="hidden text-gray-400 text-xs font-medium group-hover:text-[#1770b6] transition-colors"
        >
          Weeboste
        </span>
        <span className="text-gray-500 text-xs">|</span>
        <span className="text-gray-500 text-xs flex items-center gap-1">
          <FaCode className="text-[10px]" />
          Web Development
        </span>
      </a>
    </div>
  );

  // Alternative Developer Credit with inline styling if logo isn't available
  const DeveloperCreditSimple = () => (
    <div className="mt-6 pt-4 border-t border-gray-800 text-center">
      <a
        href="https://freelancerx.in"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center gap-2 text-gray-400 hover:text-[#1770b6] transition-all duration-300 group"
      >
        {/* <FaCode className="text-xs group-hover:rotate-6 transition-transform" /> */}
        <span className="text-xs">
          Developed by <span className="font-semibold text-gray-300 group-hover:text-[#1770b6]">FreelancerX</span>
        </span>
        <img 
          src="https://freelancerx.in/static/media/footerlogo.e53de59ccd9ef1553485.png" 
          alt="FreelancerX"
          style={{ height: '20px', width: 'auto', objectFit: 'contain', borderRadius: '10px' }}
        />
      </a>
    </div>
  );

  
  // Desktop Footer
  const DesktopFooter = () => (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="text-[#1770b6]">
              <img src={logo} alt='logo' className='h-10'/>
              </div>
              <div>
                <span className="text-2xl font-bold">
                  <span className="text-[#1770b6]">LION</span>
                  <span> HEAD</span>
                </span>
                <p className="text-sm text-gray-400">Premium Fish Food</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Providing premium quality fish food for vibrant colors, healthy growth, and optimal nutrition. Trusted by aquarium enthusiasts worldwide.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-[#1770b6] rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label={social.name}
                >
                  <span className="text-xl">{social.icon}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          {Object.values(footerLinks).map((section, idx) => (
            <div key={idx}>
              <div className="flex items-center gap-2 mb-4">
                {section.icon}
                <h3 className="text-lg font-semibold text-white">{section.title}</h3>
              </div>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <button
                      onClick={() => navigate(link.path)}
                      className="flex items-center gap-2 text-gray-400 hover:text-[#1770b6] transition-colors duration-200 text-sm"
                    >
                      <span className="text-gray-500">{link.icon}</span>
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Newsletter Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-lg font-semibold mb-2 flex items-center gap-2">
                <FaEnvelope className="text-[#1770b6]" />
                Subscribe to Our Newsletter
              </h3>
              <p className="text-gray-400 text-sm">Get the latest updates on new products and special offers.</p>
            </div>
            <form onSubmit={handleSubscribe} className="flex gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#1770b6] transition-colors"
                required
              />
              <button
                type="submit"
                className="bg-[#1770b6] hover:bg-[#0e5a94] px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-[#1770b6]/30 flex items-center gap-2"
              >
                <FaEnvelope className="text-sm" />
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Developer Credit */}

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-4 pt-4 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Lion Head. All rights reserved. | Premium Fish Food for a Better Tomorrow
          </p>
        </div>
                <DeveloperCreditSimple />

      </div>

      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-[#1770b6] text-white w-12 h-12 rounded-full shadow-lg hover:bg-[#0e5a94] transition-all duration-300 hover:scale-110 z-50 flex items-center justify-center"
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      )}
    </footer>
  );

  // Mobile Footer with App-like Bottom Navigation
  const MobileFooter = () => {
    const [activeTab, setActiveTab] = useState('home');
    
   const bottomNavItems = [
  { id: 'home', label: 'Home', icon: <FaHome className="text-2xl" />, path: '/' },
  { id: 'fish-food', label: 'Fish Food', icon: <FaShoppingCart className="text-2xl" />, path: '/fish-food' },
  { id: 'fish', label: 'Fish', icon: <FaFish className="text-2xl" />, path: '/fish' },
  { id: 'contact', label: 'Contact Us', icon: <FaEnvelope className="text-2xl" />, path: '/contact' }
];

    return (
      <>
        <footer className="bg-gray-900 text-white">
          {/* Main Footer Content - Collapsible Sections */}
          <div className="px-4 py-8 pb-24">
            {/* Brand Section */}
            <div className="text-center mb-8">
              <div className="flex items-center justify-center gap-2 mb-3">
                <div className="text-[#1770b6]">
                               <img src={logo} alt='logo' className='h-10'/>

                </div>
                <span className="text-xl font-bold">
                  <span className="text-[#1770b6]">LION</span>
                  <span> HEAD</span>
                </span>
              </div>
              <p className="text-gray-400 text-xs leading-relaxed">
                Premium quality fish food for vibrant colors and healthy growth.
              </p>
            </div>

            {/* Expandable Sections */}
            <div className="space-y-4 mb-8">
              {Object.entries(footerLinks).map(([key, section]) => (
                <details key={key} className="group">
                  <summary className="flex items-center justify-between py-3 border-b border-gray-800 cursor-pointer list-none">
                    <div className="flex items-center gap-2">
                      <span className="text-[#1770b6]">{section.icon}</span>
                      <span className="font-semibold text-white">{section.title}</span>
                    </div>
                    <span className="text-gray-400 group-open:rotate-180 transition-transform">▼</span>
                  </summary>
                  <div className="pt-3 pb-2">
                    {section.links.map((link) => (
                      <button
                        key={link.name}
                        onClick={() => navigate(link.path)}
                        className="flex items-center gap-2 w-full text-left py-2 pl-6 text-gray-400 hover:text-[#1770b6] transition-colors text-sm"
                      >
                        <span className="text-gray-500 text-xs">{link.icon}</span>
                        {link.name}
                      </button>
                    ))}
                  </div>
                </details>
              ))}
            </div>

            {/* Newsletter Subscription */}
            <div className="mb-8">
              <h3 className="text-sm font-semibold mb-3 text-center flex items-center justify-center gap-2">
                <FaEnvelope className="text-[#1770b6]" />
                Subscribe for Updates
              </h3>
              <form onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="flex-1 px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#1770b6]"
                  required
                />
                <button
                  type="submit"
                  className="bg-[#1770b6] hover:bg-[#0e5a94] px-4 py-2 rounded-lg text-sm font-semibold active:scale-95 transition-all flex items-center gap-1"
                >
                  <FaEnvelope className="text-xs" />
                  Subscribe
                </button>
              </form>
            </div>

            {/* Social Links */}
            <div className="flex justify-center gap-4 mb-6">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-[#1770b6] rounded-full flex items-center justify-center transition-all duration-300 active:scale-95"
                  style={{ color: social.color }}
                >
                  <span className="text-lg">{social.icon}</span>
                </a>
              ))}
            </div>

            {/* Developer Credit - Mobile */}
          

            {/* Copyright */}
            <div className="text-center pt-4 border-t border-gray-800 mt-4">
              <p className="text-gray-500 text-[10px]">
                © {new Date().getFullYear()} Lion Head. All rights reserved.
              </p>
            </div>
            <DeveloperCreditSimple />
          </div>
        </footer>

        {/* Bottom Navigation Bar - App-like */}
        <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-lg z-50">
          <div className="flex justify-around items-center px-2 py-2">
            {bottomNavItems.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                  setActiveTab(item.id);
                  navigate(item.path);
                }}
                className={`flex flex-col items-center py-1 px-3 rounded-lg transition-all duration-200 active:scale-95 ${
                  location.pathname === item.path || (item.id === 'home' && location.pathname === '/')
                    ? 'text-[#1770b6]'
                    : 'text-gray-400'
                }`}
              >
                <span className="mb-0.5">{item.icon}</span>
                <span className={`text-[10px] font-medium ${
                  location.pathname === item.path || (item.id === 'home' && location.pathname === '/')
                    ? 'text-[#1770b6] font-semibold'
                    : 'text-gray-400'
                }`}>
                  {item.label}
                </span>
                {(location.pathname === item.path || (item.id === 'home' && location.pathname === '/')) && (
                  <span className="absolute -top-1 w-1 h-1 bg-[#1770b6] rounded-full" />
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Back to Top Floating Button */}
        {showBackToTop && (
          <button
            onClick={scrollToTop}
            className="fixed bottom-20 right-4 bg-[#1770b6] text-white w-10 h-10 rounded-full shadow-lg active:scale-95 transition-all duration-300 z-50 flex items-center justify-center"
            aria-label="Back to top"
          >
            <FaArrowUp className="text-sm" />
          </button>
        )}

        {/* Add padding to prevent content from hiding behind bottom nav */}
        <div className="pb-16" />
      </>
    );
  };

  return isMobile ? <MobileFooter /> : <DesktopFooter />;
};

export default Footer;